import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

const Partner = () => {
  return (
    <div className="partner-usa p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                        <div className="partner_content">
                                <h2>Tailor Your Website with the Right Magento Ecommerce Development Services</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                       <p>Being a Top Magento Development Company in USA, TekRevol crafts tailored Magento e-commerce solutions to elevate your online business. With a focus on customization & seamless user experiences, our team ensures your brand stands out in the digital marketplace. From robust storefronts to intuitive navigation, we empower your e-commerce venture. Trust TekRevol's expert Magento web development services to transform your website into a sales powerhouse.</p>
                    </Col>
                </Row>
                <Row className="h-100 partner_padd">
                <Col xs={12} md={4} lg={4} xl={4} xxl={4}>
                    <div className="partner-num">
                    3rd
                    </div>
                    <div className="partner-para">
                        <p>America’s Fastest Growing Companies</p>
                    </div>
                </Col> 
                <Col xs={12} md={4} lg={4} xl={4} xxl={4}>
                    <div className="partner-num">
                    4th
                    </div>
                    <div className="partner-para">
                        <p>Top 1000 Companies</p>
                    </div>
                </Col> 
                <Col xs={12} md={4} lg={4} xl={4} xxl={4}>
                    <div className="partner-num">
                    4.4
                    </div>
                    <div className="partner-para">
                        <p>Excellence in Web Creativity & Digital Communication</p>
                    </div>
                </Col> 
                </Row>
            </Container>
    </div>
  )
}

export default Partner